"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asSocial = void 0;

var _string = require("../type-checks/string");

var asSocial = function asSocial(input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? "-" : _ref$separator;

  // Let return input be the input argument;
  var returnInput = input; // Clean all non-digit characters from input string;

  var cleanedInput = (input + "").replace(/\D/g, ""); // If cleanedInput string is of length 9;

  if ((0, _string.isStringOfLength)(cleanedInput) && cleanedInput.length === 9) {
    // Set return input to substrings, joined by separator;
    returnInput = [cleanedInput.substring(0, 3), cleanedInput.substring(3, 5), cleanedInput.substring(5)].join(separator);
  }

  return returnInput;
};

exports.asSocial = asSocial;